module.exports = {
    DontMerge: 0,
    KeepTheirs: 1,
    KeepOurs: 2
};